import { useQuery } from '@tanstack/react-query';

import { FileSystemService } from './fileSystemService';
import { FileSystemKey } from './keys';

export function useGetShared(enabled: boolean = true) {
  return useQuery({
    queryKey: [FileSystemKey.SHARED],
    queryFn: () => FileSystemService.getShared().then((response) => response.data),
    enabled: enabled,
  });
}
